import { atom } from "recoil";

const subscriptionProfileAtom = atom({
  key: "subscriptionProfile",
  default: {},
});

export default subscriptionProfileAtom;
